import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getPickHistoryListStyles = (theme: Theme) =>
  StyleSheet.create({
    listContent: {
      paddingBottom: 32,
      paddingTop: 2,
    },
    listFooter: {
      paddingVertical: 16,
      alignItems: 'center',
    },
    viewMoreButton: {
      paddingVertical: 12,
      paddingHorizontal: 24,
      borderRadius: 12,
      backgroundColor: theme.primary + '20',
      borderWidth: 1,
      borderColor: theme.primary + '50',
    },
    viewMoreButtonText: {
      fontSize: 15,
      fontWeight: '600',
      color: theme.primary,
    },
    emptyContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 32,
    },
    emptyTitle: {
      fontSize: 24,
      fontWeight: '700',
      color: theme.gray[900],
      marginBottom: 8,
    },
    emptySubtitle: {
      fontSize: 16,
      color: theme.gray[700],
      marginBottom: 24,
      textAlign: 'center',
    },
    challengeButton: {
      backgroundColor: theme.background.card,
      paddingHorizontal: 32,
      paddingVertical: 14,
      borderRadius: 12,
      shadowColor: theme.shadow,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 8,
      elevation: 6,
    },
    challengeButtonText: {
      color: theme.primary,
      fontSize: 16,
      fontWeight: '700',
    },
    sectionHeaderTouchable: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingVertical: 12,
      paddingTop: 8,
    },
    sectionHeaderTouchableCollapsed: {
      backgroundColor: theme.gray[100],
      borderRadius: 12,
      marginHorizontal: 16,
      marginBottom: 8,
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    sectionHeaderTitle: {
      fontSize: 20,
      fontWeight: '800',
      color: theme.gray[900],
    },
    sectionHeaderChevron: {
      opacity: 0.7,
    },
    sectionHeaderChevronCollapsed: {
      opacity: 1,
    },
    sectionHeaderSubtext: {
      fontSize: 13,
      color: theme.gray[500],
      fontWeight: '500',
      marginLeft: 4,
    },
    sectionHeaderRightRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    removeFriendFooter: {
      paddingVertical: 24,
      paddingHorizontal: 16,
      alignItems: 'center',
      borderTopWidth: 1,
      borderTopColor: theme.gray[200],
      marginTop: 8,
    },
    removeFriendButton: {
      paddingVertical: 12,
      paddingHorizontal: 24,
      borderRadius: 12,
      backgroundColor: theme.error,
      minWidth: 160,
      alignItems: 'center',
    },
    removeFriendButtonText: {
      fontSize: 15,
      color: theme.textOnStatusBadge,
      fontWeight: '600',
    },
    // Coins balance section
    coinGradient: {
      borderRadius: 16,
      marginBottom: 8,
      paddingVertical: 28,
      paddingHorizontal: 16,
      alignItems: 'center',
    },
    coinHeaderRow: {
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      marginBottom: 10,
    },
    coinHeaderSpacer: {
      width: 36,
    },
    coinHeaderLabel: {
      flex: 1,
      textAlign: 'center',
      fontSize: 11,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 1.5,
      textTransform: 'uppercase',
    },
    coinTooltipSpacer: {
      width: 36,
      alignItems: 'flex-end',
    },
    coinValueOuter: {
      alignItems: 'center',
      width: '100%',
    },
    coinValueRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    coinValueSpacer: {
      width: 36,
    },
    coinImage: {
      width: 36,
      height: 36,
    },
  });

export const getCoinDeltaTextStyle = (color: string, fontSize: number) =>
  ({
    fontSize,
    fontWeight: '900' as const,
    color,
    letterSpacing: -1,
    textShadowColor: color,
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 12,
  });
